import { i18n } from '@/i18n'

export const getExistingUrlFulfillment = ({ meta_key_url, channel_type = null, id = null }) => {
  if (!meta_key_url) {
    return null
  }

  switch (meta_key_url) {
    case 'fulfillment':
      return '/fulfillment'

    case 'fulfillment-detail':
      return '/fulfillment/detail'

    case 'fulfillment-detail-update-order':
      return '/fulfillment/detail/update-order'

    case 'delivery-order':
      return '/delivery-order'

    case 'delivery-order-detail':
      return '/delivery-order/detail'

    case 'delivery-order-detail-update-order':
      return '/delivery-order/detail/update-order'

    case 'channel-fulfillment':
      return `/channel/${id}/${channel_type}/fulfillment`

    case 'channel-fulfillment-detail':
      return `/channel/${id}/${channel_type}/fulfillment/detail`

    case 'channel-fulfillment-detail-update-order':
      return `/channel/${id}/${channel_type}/detail/update-order`

    default:
      return null
  }
}

export const urlToDetailFulfillment = ({ meta_key_url, channel_type = null, id = null }) => {
  if (!meta_key_url) {
    return null
  }

  switch (meta_key_url) {
    case 'fulfillment':
    case 'fulfillment-detail-update-order':
      return '/fulfillment/detail'

    case 'delivery-order':
    case 'delivery-order-detail-update-order':
      return '/delivery-order/detail'

    case 'channel-fulfillment':
    case 'channel-fulfillment-detail-update-order':
    case 'channel-fulfillment-stock-inventory':
      return `/channel/${id}/${channel_type}/fulfillment/detail`

    default:
      return null
  }
}

export const getUrlAfterDetailFulfillment = ({ meta_key_url, channel_type = null, id = null }) => {
  if (!meta_key_url) {
    return null
  }

  if (meta_key_url === 'fulfillment-detail') {
    return '/fulfillment'
  }

  if (meta_key_url === 'delivery-order-detail') {
    return '/delivery-order'
  }

  if (meta_key_url === 'channel-fulfillment-detail') {
    return `/channel/${id}/${channel_type}/fulfillment`
  }

  return null
}

export const getUrlToUpdateOrderFromFulfillmentDetailPage = ({ meta_key_url, channel_type = null, id = null }) => {
  if (!meta_key_url) {
    return null
  }

  switch (meta_key_url) {
    case 'fulfillment-detail':
      return '/fulfillment/detail/update-order'

    case 'delivery-order-detail':
      return '/delivery-order/detail/update-order'

    case 'channel-fulfillment-detail':
      return `/channel/${id}/${channel_type}/fulfillment/detail/update-order`

    default:
      return null
  }
}

export const setBackgroundColorStatus = (param) => {
  if (!param) {
    return null
  }

  const value = param.toLowerCase()

  if (['confirmed', 'created', 'selesai'].find(item => item === value)) {
    return '#0A89FF'
  }

  if (['split_shipment', 'split_fulfillment'].find(item => item === value)) {
    return '#454655'
  }

  if (['accepted'].find(item => item === value)) {
    return '#00BBD9'
  }

  if (['pick_confirmed', 'packing_completed'].find(item => item === value)) {
    return '#999999'
  }

  if (['good_issued', 'shipped'].find(item => item === value)) {
    return '#2D9500'
  }

  if (['delivered', 'buyer_accepted'].find(item => item === value)) {
    return '#4d4d4d'
  }

  if (['canceled', 'cancel_requested', 'gagal', 'good_issued_canceled', 'deleted'].find(item => item === value)) {
    return '#E00000'
  }

  return '#EC4426'
}

export const setWordingBookingState = (param) => {
  if (!param) {
    return '-'
  }

  const value = param.toLowerCase()

  switch (value) {
    case 'not_yet_allocated':
      return 'Pending'

    case 'success_allocated':
      return 'Booked'

    case 'allocation_failed':
      return 'OOS'

    default:
      // eslint-disable-next-line no-case-declarations
      const text = value.replace('_', ' ')
      return text[0].toUpperCase() + text.slice(1).toLowerCase()
  }
}

export const setWordingFulfillmentState = (param, state) => {
  if (!param) {
    return null
  }

  const value = param.toLowerCase()

  if (['confirmed', 'created'].find(item => item === value)) {
    return i18n.t('fulfillment.created')
  }

  if (['split_shipment', 'split_fulfillment'].find(item => item === value)) {
    return i18n.t('fulfillment.separateShipment')
  }

  if (['accepted'].find(item => item === value)) {
    return i18n.t('fulfillment.do_process')
  }

  if (['pick_confirmed'].find(item => item === value)) {
    return i18n.t('fulfillment.picking')
  }

  if (['good_issued'].find(item => item === value)) {
    return i18n.t('fulfillment.readyToShip')
    // return state?.toLowerCase() === 'delivered'
    //   ? 'Terkirim'
    //   : state?.toLowerCase() === 'created'
    //   ? 'Siap Dikirim'
    //   : 'Pengiriman'
  }

  if (['packing_completed'].find(item => item === value)) {
    return i18n.t('fulfillment.packing')
  }

  if (['shipped'].find(item => item === value)) {
    return i18n.t('fulfillment.inDelivery')
  }

  if (['delivered', 'buyer_accepted'].find(item => item === value)) {
    return i18n.t('fulfillment.delivered')
  }

  if (['canceled', 'good_issued_canceled', 'deleted'].find(item => item === value)) {
    return i18n.t('fulfillment.canceled')
  }

  if (['return_requested'].find(item => item === value)) {
    return i18n.t('fulfillment.return_requested')
  }

  if (['returned'].find(item => item === value)) {
    return i18n.t('fulfillment.returned')
  }

  if (['cancel_requested'].find(item => item === value)) {
    return i18n.t('fulfillment.cancel_requested')
  }

  return null
}

export const getFallbackShippingLabelUrl = ({ channelCode, businessId, orderNumber }) => {
  if (!businessId || !orderNumber) {
    return null
  }

  const normalizedChannel = (channelCode || '').toLowerCase()
  let pathChannel = ''

  if (['shopee', 'shopee_id'].includes(normalizedChannel) || normalizedChannel.startsWith('shopee')) {
    pathChannel = process.env.VUE_APP_SHIPPING_LABEL_PATH_SHOPEE || '/channel/shopee/order/query'
  } else if (['tiktok', 'tiktok_id', 'tiktok_tokopedia'].includes(normalizedChannel) || normalizedChannel.startsWith('tiktok')) {
    pathChannel = process.env.VUE_APP_SHIPPING_LABEL_PATH_TIKTOK || '/channel/tiktok/order'
  } else {
    return null
  }

  const baseUrl = (process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')
  if (!baseUrl) return null
  const cleanPath = pathChannel.replace(/^\/+|\/+$/g, '')

  let encodedOrderNumber = ''
  try {
    encodedOrderNumber = window.btoa(unescape(encodeURIComponent(String(orderNumber))))
  } catch (e) {
    try {
      encodedOrderNumber = window.btoa(String(orderNumber))
    } catch (err) {
      console.error('Failed to encode order number to base64:', err)
      return null
    }
  }

  return `${baseUrl}/${cleanPath}/public/shipping-label/${businessId}/${encodedOrderNumber}`
}

